import logConstituentActivity from "@utils/logConstituentActivity";

export default function logConstituentActivityError(context, options = {}) {
  return logConstituentActivity(window.location.href, {
    description: context,
    activityType: "page_load_error",
    ...options,
  });
}
